import type { BaseDataItem } from '@wix/thunderbolt-becky-types'

export interface IDocumentDataStore {
	updateData(id: string, dataItem: BaseDataItem | undefined): BaseDataItem | undefined
	getData<T extends BaseDataItem = BaseDataItem>(id: string): T | undefined
}
export class DocumentDataStore implements IDocumentDataStore {
	private readonly data: Record<string, any> = {}
	private readonly cache: Record<string, any> = {}

	private updateCache(id: string) {
		const original = this.data[id]
		if (original?.type === 'Repeater') {
			this.cache[id] = this.data[id]
			return
		}
		this.cache[id] = this.data[id]
	}

	updateData(id: string, dataItem: BaseDataItem | undefined) {
		this.data[id] = dataItem
		this.updateCache(id)
		return this.cache[id]
	}

	getData(id: string) {
		return this.cache[id]
	}
}
